import { Model } from 'shared/services/api/models/Model'

import { NotepadProductOfferPriceV1 } from './notepadResponseTypes'
import { NotepadProductOfferBasePrice } from './notepadProductOfferBasePrice'

export class NotepadProductOfferPrice extends Model {
  public basePrice: NotepadProductOfferBasePrice
  public currency: string
  public price: number
  public shippingPrice: number
  public totalPrice: number

  constructor(src: NotepadProductOfferPriceV1) {
    super(src)
    this.basePrice = src.basePrice
      ? new NotepadProductOfferBasePrice(src.basePrice)
      : null
    this.currency = src.currency
    this.price = src.price
    this.shippingPrice = src.shippingPrice
    this.totalPrice = src.totalPrice
  }
}
